import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconPath } from '@app/shared/common/icons';
import { AppointmentType } from '@app/shared/models/data/appointment-types/AppointmentType';
import { IconsDefinitionHelper } from '@shared/common/definition-helper';
import {BubbleColour} from '@shared/components/bubble/bubble.component';
import { LocalizedDatePipe } from '@shared/pipes/localized-date/localized-date.pipe';
import { IconComponent } from '../icon/icon.component';
import { BubbleComponent } from '../bubble/bubble.component';


@Component({
    selector: 'app-small-list-item',
    templateUrl: './small-list-item.component.html',
    styleUrls: ['./small-list-item.component.scss'],
    standalone: true,
    imports: [BubbleComponent, IconComponent, LocalizedDatePipe]
})
export class SmallListItemComponent extends IconsDefinitionHelper implements OnInit {
  @Input() bubbleColour: BubbleColour = null;
  @Input() date: string = null;
  @Input() dateFormat = 'shortDate'; // the angular date format
  @Input() text: string = null;
  @Input() isClickable = false;
  @Input() icon: IconPath = null;

  @Input() set iconPath(path: string) {
    this.icon = AppointmentType.mapToIcon(path);
  }
  @Input() hoverTitle: string = null; // when the user hovers over a small list item, what value to show

  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit(): void {
    this.hoverTitle = this.hoverTitle ?? this.text;
  }

  click(): void {
    this.clicked.emit();
  }
}
